import { __decorate, __metadata } from "tslib";
import { Component, Ref } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import { LvLoadingOverlay } from "../loading-overlay";
export const COMPONENT_NAME = "LvModal";
let LvModal = class LvModal extends UIComponent {
    constructor() {
        super(...arguments);
        this.isVisible = false;
        this.isLoading = false;
    }
    onBackdropClick() {
        this.hide();
        this.$emit("dismiss");
    }
    show() {
        this.isVisible = true;
    }
    hide() {
        this.isVisible = false;
    }
    shake() {
        const animationEndEventListener = (event) => {
            if (event.target != this.modalContainer)
                return;
            this.modalContainer.classList.remove("lv-modal-container-shake");
            this.modalContainer.removeEventListener("animationend", animationEndEventListener);
        };
        this.modalContainer.addEventListener("animationend", animationEndEventListener);
        this.modalContainer.classList.add("lv-modal-container-shake");
    }
};
__decorate([
    Ref(),
    __metadata("design:type", HTMLDivElement)
], LvModal.prototype, "modalContainer", void 0);
LvModal = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: { LvLoadingOverlay },
    })
], LvModal);
export default LvModal;
//# sourceMappingURL=script.js.map